import React, { useContext, useState } from 'react';
import { Card, Row, Col } from "react-bootstrap"
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { useTranslation } from 'react-i18next';
import { Icon, IconButton } from '@fluentui/react';
import { __onGoToBoardEP, __onGoToBoardHome, __onGoToBoardKpiOperational, __onGoToBook, __onGoToConfigPartiesEP, __onGoToElementObligationAchives, __onGoToGap, __onGoToGapV2 } from '../../../../../../common/SystemRedirections';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import { enum__BOARD_TEMPLATE_TYPE, enum__PRIVILEGE_APP } from '../../../../../../common/Dictionaries';
import { isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import { useSelector } from 'react-redux';
import MainAppContext from '../../../../../../MainAppContext';
 
const ELEMENT_STADISTICS = (props) => {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    
    const { token: currentAuth } = useSelector((state) => state.auth);

    const { 
        inputParam_ElementId = null,
        inputParam_HideHeader = false,
        inputParam_ComponentContent = null,
        inputParam_ComponentConfig = null,
        inputParam_UseFake = false,
        inputParam_BoardStructure = null,
        inputParam_Container = null,
    } = props;

    const fackeClick = () => { return }

    const decodeApps = (number) => {
        const apps = [];
        const values = Object.values(enum__PRIVILEGE_APP).sort((a, b) => b - a);
    
        for (let value of values) {
            if (number >= value) {
                number -= value;
                apps.push(value);
            }
        }
    
        return apps;
    }

    const onCalculateBookAndGo = (items) => {
        const bookItem = inputParam_ComponentContent.items.find(x => x.stadisticName === "messages")
        const bookId = !isNullUndefined(bookItem) ? bookItem.stadisticPath : null

        if (bookId !== null) {
            __onGoToBook(bookId);
        }
    }

    const [cards, setCards] = useState([
        {
            keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
            icon: "Financial",
            text: t('data-lang-lbl-kpiboard'),
            color: "#115E8C",
            stadisticName: 'dataseries',
            onClick: !inputParam_UseFake ? () => __onGoToBoardKpiOperational(inputParam_ElementId, enum__BOARD_TEMPLATE_TYPE.OPERATIONAL) : fackeClick,
            _fakeValue: Math.floor(Math.random() * 50),
            value: null
        },{
            keyTypeUniqueId: enum__PRIVILEGE_APP.KPI,
            icon: "NewsSearch",
            text: t('data-lang-lbl-performancedialogues'),
            color: "#00BF3E",
            stadisticName: 'dialogos',
            onClick: !inputParam_UseFake ? () => __onGoToGapV2(inputParam_ElementId) : fackeClick,
            _fakeValue: Math.floor(Math.random() * 50),
            value: null
        },{
            keyTypeUniqueId: enum__PRIVILEGE_APP.BOOK,
            icon: "PublishCourse",
            text: t('data-lang-lbl-communications-lower'),
            color: "#16C2D0",
            stadisticName: 'messages',
            onClick: !inputParam_UseFake ? () => onCalculateBookAndGo(inputParam_ComponentContent.items) : fackeClick,
            _fakeValue: Math.floor(Math.random() * 50),
            value: null
        },{
            keyTypeUniqueId: enum__PRIVILEGE_APP.EDP,
            icon: "Trackers",
            text: t('data-lang-lbl-parties'),
            color: "#F24656",
            stadisticName: "partidas",
            onClick: !inputParam_UseFake ? () => __onGoToConfigPartiesEP(inputParam_ElementId) : fackeClick,
            _fakeValue: Math.floor(Math.random() * 50),
            value: null
        },{
            keyTypeUniqueId: enum__PRIVILEGE_APP.EDP,
            icon: "AllCurrency",
            text: t('data-lang-lbl-edps'),
            color: "#FF8F29",
            stadisticName: 'edps',
            onClick: !inputParam_UseFake ? () => __onGoToBoardEP(inputParam_ElementId) : fackeClick,
            _fakeValue: Math.floor(Math.random() * 50),
            value: null
        },{
            keyTypeUniqueId: enum__PRIVILEGE_APP.CO,
            icon: "EventDateMissed12",
            text: t('data-lang-lbl-co-long'),
            color: "#919f10b4",
            stadisticName: 'obligaciones',
            onClick: !inputParam_UseFake ? () => __onGoToElementObligationAchives(inputParam_ElementId, 0) : fackeClick,
            _fakeValue: Math.floor(Math.random() * 50),
            value: null
        }
    ].filter(card => inputParam_ComponentContent !== null && inputParam_ComponentContent.items.length > 0 ?
        inputParam_ComponentContent.items.some(dinamyc => dinamyc.stadisticName === card.stadisticName) : true
    ).filter(
                card => inputParam_ComponentContent !== null && inputParam_ComponentContent.items.length > 0 ?
                (
                    card.stadisticName === "messages" ?
                    inputParam_ComponentContent.items.some(dinamyc => dinamyc.stadisticName === 'messages' && dinamyc.stadisticPath !== "")
                    : true
                )
                : true
            ).filter(x => contextSite.securityProps.l_products.some(product => product.toLowerCase() === x.keyTypeUniqueId.toLowerCase()))
    );

    const renderHorizontal = () => {
        return  <>
                    <Row className='py-0 h-1001'>
                    {
                        cards.filter(x => x.stadisticName !== null).map((card, index) => {

                            const value = inputParam_ComponentContent.items.find(x => x.stadisticName === card.stadisticName) !== undefined ?
                            inputParam_ComponentContent.items.find(x => x.stadisticName === card.stadisticName).stadisticValue: "";

                            return  <Col key={index} className='border mx-1 h-100'>
                                        <Row className='border' style={{backgroundColor: card.color, color: "white"}}>
                                            <Row>
                                                <Col className='col-auto me-auto m-0 p-0'>
                                                    <Icon iconName={card.icon} styles={{root: { fontSize: "32px" }}} />
                                                </Col>
                                                <Col className='font-weight-bold text-end col-auto ms-auto m-0 p-0' style={{fontSize: '18px'}}>{value}</Col>
                                            </Row>
                                            <Col className='col-auto ms-auto px-1'>{card.text}</Col>
                                        </Row>
                                        <Row className=''>
                                            <Col>
                                            </Col>
                                            <Col className='col-auto ms-auto d-flex my-auto'>
                                                <div className='pt-1'>{t('data-lang-lbl-details')}</div>
                                                <IconButton onClick={card.onClick} iconProps={{iconName: 'SkypeCircleArrow'}} styles={{root: { color: card.color, fontSize: "16px", transform: "rotate(-180deg)" }}} />
                                            </Col>
                                        </Row>
                                    </Col>
                        })
                    }
                    </Row>
                </>
    }

    const renderVertical = () => {
        return  <>
                    <Row>
                    {
                        cards.filter(x => x.stadisticName !== null).map((card, index) => {
                            
                            const value = inputParam_ComponentContent.items.find(x => x.stadisticName === card.stadisticName) !== undefined ?
                            inputParam_ComponentContent.items.find(x => x.stadisticName === card.stadisticName).stadisticValue: "";

                            return  <Col key={index} xl={12} className='border my-1'>
                                        <Row>
                                            <Col className='me-auto px-1' style={{backgroundColor: card.color, color: "white"}}>
                                                <Row>
                                                    <Col className='col-auto'><Icon iconName={card.icon} styles={{root: { fontSize: "30px" }}} /></Col>
                                                    <Col className='my-auto'>{card.text}</Col>
                                                    <Col className='font-weight-bold col-auto me-auto my-auto'>{value}</Col>
                                                </Row>
                                            </Col>
                                            <Col className='col-auto d-flex my-auto px-1'>
                                                <div className='pt-1'>{t('data-lang-lbl-details')}</div>
                                                <IconButton onClick={card.onClick} iconProps={{iconName: 'SkypeCircleArrow'}} styles={{root: { color: card.color, fontSize: "16px", transform: "rotate(-180deg)" }}} />
                                            </Col>
                                        </Row>
                                    </Col>
                        })
                    }
                    </Row>
                </>
    }

    const parseComponentAPIStyle = () => {
        if (!isNullUndefinedOrEmpty(inputParam_ComponentConfig.htmlStyle)) {
            const objectParsed = JSON.parse(inputParam_ComponentConfig.htmlStyle);

            return objectParsed;
        }

        return null
    }

    const componentApiStyle = parseComponentAPIStyle();

    return (
                <Card className='board-element-form h-100'>
                    {
                        !inputParam_HideHeader &&
                        <Card.Header className="card-header-compact">
                            <Card.Title className="d-flex justify-content-between">
                                {
                                    inputParam_ComponentContent !== null ?
                                    <b>{inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-stadistic')}</b> :
                                    <b>{t('data-lang-boxname-stadistic')}</b>
                                }
                                <div className='toolbar d-flex'>
                                    <HEADER_TOOLBAR
                                        inputParam_BoardStructure={inputParam_BoardStructure}
                                        inputParam_Container={inputParam_Container}
                                    />
                                </div>
                            </Card.Title>
                        </Card.Header>
                    }
                    <Card.Body className='mx-1 py-1'>
                        {
                            inputParam_ComponentContent !== null ?
                            <>
                                {
                                    componentApiStyle !== null ? (componentApiStyle.componentBehavior?.horizontal === true ? renderHorizontal() : renderVertical()) : renderHorizontal()
                                }
                            </> : <NoDataLayer display={true} />
                        }
                    </Card.Body>
                </Card>
    );
}
export default ELEMENT_STADISTICS;